export const dropdownOptions = [
    { value: "", label: 'Select Title', disabled: true, hidden: true },
    { value: "engineering", label: 'Engineering' },
    { value: "marketing", label: 'Marketing' },
    { value: "sales", label: 'Sales' },
    { value: "hr", label: 'Human Resources' },
];

export const jobOpeningStatusOptions = [
    { value: "", label: "Select Status", disabled: true, hidden: true },
    { value: "open", label: "Open" },
    { value: "in_progress", label: "In Progress" },
    { value: "closed", label: "Closed" },
    { value: "on_hold", label: "On Hold" },
    { value: "cancelled", label: "Cancelled" },
];

export const jobTypeOptions = [
    { value: "", label: "Select Job Type", disabled: true, hidden: true },
    { value: "full_time", label: "Full-Time" },
    { value: "part_time", label: "Part-Time" },
    { value: "contract", label: "Contract" },
    { value: "internship", label: "Internship" },
    { value: "freelance", label: "Freelance" },
];

export const countryOptions = [
    { value: "", label: "Select Country", disabled: true, hidden: true },
    { value: "us", label: "United States" },
    { value: "ca", label: "Canada" },
    { value: "uk", label: "United Kingdom" },
    { value: "in", label: "India" },
    { value: "de", label: "Germany" },
    { value: "fr", label: "France" },
    { value: "au", label: "Australia" },
    { value: "jp", label: "Japan" },
    { value: "cn", label: "China" },
    { value: "br", label: "Brazil" },
  ];

  export const requiredSkillsOptions = [
    { value: "", label: "Select Skill", disabled: true, hidden: true },
    { value: "javascript", label: "JavaScript" },
    { value: "react", label: "React.js" },
    { value: "nodejs", label: "Node.js" },
    { value: "python", label: "Python" },
    { value: "java", label: "Java" },
    { value: "csharp", label: "C#" },
    { value: "sql", label: "SQL" },
    { value: "aws", label: "AWS" },
    { value: "docker", label: "Docker" },
    { value: "kubernetes", label: "Kubernetes" },
    { value: "git", label: "Git" },
  ];

export const interviewerOptions = [
    { value: "", label: "Select Interviewer", disabled: true, hidden: true },
    { value: "martina_nikolaus", label: "Martina Nikolaus" },
    { value: "jermain_beatty", label: "Jermain Beatty" },
    { value: "bertram_roberts", label: "Mr. Bertram Roberts Sr." },
    { value: "meggie_streich", label: "Meggie Streich" },
    { value: "johnson_veum", label: "Dr. Johnson Veum Sr." },
    { value: "giles_conn", label: "Giles Conn" },
];

export const interviewRoundOptions = [
    { value: "", label: "Select Interview Round", disabled: true, hidden: true },
    { value: "technical_round", label: "Technical Round" },
    { value: "hr_round", label: "HR Round" },
    { value: "manager_round", label: "Manager Round" },
];

export const interviewTypeOptions = [
    { value: "", label: "Select Interview Type", disabled: true, hidden: true },
    { value: "in_person", label: "In Person" },
    { value: "video", label: "Video" },
    { value: "phone", label: "Phone" },
];

export const candidateOptions = [
    { value: "", label: "Select Candidate", disabled: true, hidden: true },
    { value: "keanu_bailey_sr", label: "Keanu Bailey Sr." },
    { value: "colten_mcglynn", label: "Colten McGlynn" },
    { value: "demario_greenholt", label: "Demario Greenholt" },
    { value: "sylvester_kessler", label: "Sylvester Kessler" },
    { value: "chelsey_abernathy", label: "Chelsey Abernathy" },
  ];

export const totalExperienceOptions = [
    { value: "", label: "Select Experience", disabled: true, hidden: true },
    { value: "0-1", label: "0-1 Years" },
    { value: "1-2", label: "1-2 Years" },
    { value: "2-3", label: "2-3 Years" },
    { value: "3-5", label: "3-5 Years" },
    { value: "5-7", label: "5-7 Years" },
    { value: "7-10", label: "7-10 Years" },
    { value: "10+", label: "10+ Years" },
];

export const noticePeriodOptions = [
    { value: "", label: "Select Notice Period", disabled: true, hidden: true },
    { value: "immediate", label: "Immediate" },
    { value: "15_days", label: "15 Days" },
    { value: "30_days", label: "30 Days" },
    { value: "60_days", label: "60 Days" },
    { value: "90_days", label: "90 Days" },
    { value: "more_than_90", label: "More than 90 Days" },
];

export const applicationSourceOptions = [
    { value: "", label: "Select Application Source", disabled: true, hidden: true },
    { value: "linkedin", label: "LinkedIn" },
    { value: "naukri", label: "Naukri" },
    { value: "indeed", label: "Indeed" },
    { value: "monster", label: "Monster" },
    { value: "glassdoor", label: "Glassdoor" },
    { value: "company_website", label: "Company Website" },
    { value: "referral", label: "Referral" },
    { value: "social_media", label: "Social Media" },
    { value: "others", label: "Others" },
];

export const reminderOptions = [
    { value: "", label: "Select Reminder Type", disabled: true, hidden: true },
    { value: "days", label: "Day(s)" },
    { value: "hours", label: "Hour(s)" },
    { value: "minutes", label: "Minute(s)" },
];